import React, { Component } from 'react';
import {
  Container,
  Segment,
  Form,
  Header,
  Message,
  Table,
  Pagination,
  Icon,
  Loader,
  Dimmer,
  Button,
  Popup
} from 'semantic-ui-react';
import moment from 'moment';

export default class index extends Component {
  constructor(props) {
    super(props);

    const currentYear = moment().year();
    const globalMinYear = currentYear - 20;
    const yearOptions = this.createYearOptions(currentYear - 20);

    this.state = {
      globalMinYear,
      rangeFieldNames: [
        'minYear',
        'maxYear',
        'minPrice',
        'maxPrice',
        'minMileage',
        'maxMileage',
        'latitude',
        'longitude',
        'mileageRadius'
      ],
      equalityOptions: [
        { key: 'lessThan', text: 'less than', value: 'lessThan' },
        { key: 'equalTo', text: 'equal to', value: 'equalTo' },
        { key: 'greaterThan', text: 'greater than', value: 'greaterThan' }
      ],
      vehicleStateOptions: [
        { key: 'new', text: 'New', value: 'new' },
        { key: 'cpo', text: 'CPO', value: 'cpo' },
        { key: 'used', text: 'Used', value: 'used' }
      ],
      minYearOptions: [...yearOptions],
      maxYearOptions: [...yearOptions],
      mileageOptions: this.createMileageOptions(25 * 6, 25),
      form: {
        // <filed name>: value
      },
      inputFieldForm: {
        make: null
      },
      queryUrl: null,
      queryTimeoutId: null,
      pagination: {
        activePage: 1,
        totalPages: 1
      },
      data: [],
      loading: false
    };
  }

  createYearOptions = (minYear) => {
    const yearList = this.createListOfYears(minYear);

    return yearList.map((year) => {
      return {
        key: year,
        text: year,
        value: year
      };
    });
  };

  createListOfYears = (minYear) => {
    const nextYear = moment().year() + 1;

    if (minYear > nextYear)
      throw new Error('The minimum year must be less than the current year.');

    const difference = nextYear - minYear;

    const yearList = [];
    for (let offset = 0; offset <= difference; offset += 1) {
      yearList.push(nextYear - offset);
    }

    return yearList;
  };

  createMileageOptions = (maxMileage, step) => {
    if (maxMileage < step) return [];

    const initialMileage = step;
    const initialOffset = 0;

    const mileageList = this.mileageAfterStep(
      initialMileage,
      maxMileage,
      step,
      initialOffset
    );

    return mileageList.map((mileage) => ({
      key: `${mileage} mi`,
      text: `${mileage} mi`,
      value: mileage
    }));
  };

  /**
   * maxMileage and step should be const.
   */
  mileageAfterStep = (currentMileage, maxMileage, step, offset) => {
    if (maxMileage <= currentMileage + step * offset) return [maxMileage];

    const nextOffset = offset + 1;
    const nextMileage = currentMileage + step * nextOffset;

    return [currentMileage].concat(
      this.mileageAfterStep(nextMileage, maxMileage, step, nextOffset)
    );
  };

  onResetButtonClick = () => {
    const { inputFieldForm } = this.state;

    const newInputFieldForm = {};
    Object.keys(inputFieldForm).forEach((key) => {
      if (key === 'vehicle_state') {
        newInputFieldForm[key] = undefined;
      } else {
        newInputFieldForm[key] = '';
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      inputFieldForm: newInputFieldForm,
      form: {},
      data: [],
      loading: false,
      error: null,
      queryUrl: this.createQueryUrl({})
    }));
  };

  onFieldChange = (event, data) => {
    const { name, value } = data;

    this.setState(
      {
        ...this.state,
        inputFieldForm: {
          ...this.state.inputFieldForm,
          [name]: value
        }
      },
      () => {
        this.updateField(data);
      }
    );
  };

  updateField = ({ name, value }) => {
    const { form, rangeFieldNames } = this.state;

    console.log(form, value);
    // if value is empty, remove the form field..
    if (
      !value ||
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0)
    ) {
      const newForm = { ...form };

      delete newForm[name];

      // if the name is one of the range field name, we need to delete the corresponding key in the form.
      if (rangeFieldNames.indexOf(name) !== -1) {
        switch (name) {
          case 'minYear':
          case 'maxYear':
            delete newForm.year;
            break;

          case 'minPrice':
          case 'maxPrice':
            delete newForm.price;
            break;

          case 'latitude':
          case 'longitude':
          case 'mileageRadius':
            delete newForm.location;
            break;

          default:
            // mileage case
            delete newForm.mileage;
            break;
        }
      }

      this.setState(
        {
          ...this.state,
          form: newForm
        },
        () => {
          const { form: updatedForm } = this.state;

          this.updateQueryUrlAndFetch(updatedForm);
        }
      );

      return;
    }

    if (rangeFieldNames.indexOf(name) !== -1) {
      const newState = { ...this.state };
      const newForm = { ...form };

      // if minYear is selected already, maxYear that is less than minYear cannot be selected.
      // the opposite case has to be handled as well.
      // Also, if both minYear and maxYear are present in the form,
      // add {year: minYear,maxYear } in the form.
      if (name === 'minYear' || name === 'maxYear') {
        // year
        // if one of minYear or maxYear is not present in the form, delete { year: ... } from the from.

        // if both year fields are not present, we need to delete it because the query is all based on the form and its keys.
        const isBothYearFieldsPresent = this.isBothRangeFieldsValid(
          newForm,
          name,
          'minYear',
          'maxYear'
        );

        if (!isBothYearFieldsPresent) {
          delete newForm.year;
        } else {
          // both year fields are present
          newForm.year = `${name === 'minYear' ? value : newForm.minYear},${
            name === 'maxYear' ? value : newForm.maxYear
          }`;
        }

        const { globalMinYear } = this.state;

        const yearOptions = this.createListOfYears(globalMinYear);

        newState.minYearOptions =
          name === 'minYear'
            ? newState.minYearOptions
            : yearOptions
                .filter((year) => year <= value)
                .map((year) => ({
                  key: year,
                  text: year,
                  value: year
                }));

        newState.maxYearOptions =
          name === 'minYear'
            ? yearOptions
                .filter((year) => year >= value)
                .map((year) => ({
                  key: year,
                  text: year,
                  value: year
                }))
            : newState.maxYearOptions;
      } else if (name === 'minPrice' || name === 'maxPrice') {
        // price
        const isBothPriceFieldsPresent = this.isBothRangeFieldsValid(
          newForm,
          name,
          'minPrice',
          'maxPrice'
        );
        if (!isBothPriceFieldsPresent) {
          delete newForm.price;
        } else {
          newForm.price = `${name === 'minPrice' ? value : newForm.minPrice},${
            name === 'maxPrice' ? value : newForm.maxPrice
          }`;
        }
      } else if (name === 'minMileage' || name === 'maxMileage') {
        // mileage
        const isBothMileageFieldsPresent = this.isBothRangeFieldsValid(
          newForm,
          name,
          'minMileage',
          'maxMileage'
        );
        if (!isBothMileageFieldsPresent) {
          delete newForm.mileage;
        } else {
          newForm.mileage = `${
            name === 'minMileage' ? value : newForm.minMileage
          },${name === 'maxMileage' ? value : newForm.maxMileage}`;
        }
      } else {
        const keysInForm = Object.keys(newForm);

        // when name is latitude, longitude or mileageRadius
        const isAllLocationFieldsPresent =
          (name === 'latitude' &&
            keysInForm.indexOf('longitude') !== -1 &&
            keysInForm.indexOf('mileageRadius') !== -1) ||
          (name === 'longitude' &&
            keysInForm.indexOf('latitude') !== -1 &&
            keysInForm.indexOf('mileageRadius') !== -1) ||
          (name === 'mileageRadius' &&
            keysInForm.indexOf('latitude') !== -1 &&
            keysInForm.indexOf('longitude') !== -1);

        if (!isAllLocationFieldsPresent) {
          delete newForm.location;
        } else {
          newForm.location = `${
            name === 'latitude' ? value : newForm.latitude
          }, ${name === 'longitude' ? value : newForm.longitude},${
            name === 'mileageRadius' ? value : newForm.mileageRadius
          }`;
        }
      }

      this.setState(
        {
          ...newState,
          form: {
            ...newForm,
            [name]: value
          }
        },
        () => {
          const { form: updatedForm } = this.state;

          this.updateQueryUrlAndFetch(updatedForm);
        }
      );

      return;
    }

    this.setState(
      {
        ...this.state,
        form: {
          ...this.state.form,
          [name]:
            name === 'price' || name === 'mileage' ? parseFloat(value) : value
        }
      },
      () => {
        const { form: updatedForm } = this.state;

        this.updateQueryUrlAndFetch(updatedForm);
      }
    );
  };

  updateQueryUrlAndFetch = (form, activePage = 1) => {
    const queryUrl = this.createQueryUrl(form, activePage);

    if (!queryUrl) {
      // form does not have any conditions
      this.setState((prevState) => ({
        ...prevState,
        loading: false,
        queryUrl: null,
        data: []
      }));

      return;
    }

    this.setState(
      {
        ...this.state,
        queryUrl,
        loading: true,
        error: null
      },
      () => {
        const { queryUrl: updatedQueryUrl, queryTimeoutId } = this.state;

        if (!updatedQueryUrl) return;

        if (queryTimeoutId) clearTimeout(queryTimeoutId);

        const newTimeoutId = setTimeout(async () => {
          try {
            const response = await fetch(updatedQueryUrl, {
              method: 'GET',
              headers: {
                'x-api-key': 'key'
              }
            });

            const { status } = response;

            if (status >= 300) {
              this.setState((prevState) => ({
                ...prevState,
                loading: false,
                error: {
                  title: 'Something went wrong!!',
                  message:
                    'There was issue while retrieving data. Please try it again.'
                }
              }));

              return;
            }

            const {
              activePage: returnedActivePage,
              data,
              totalPages
            } = await response.json();

            this.setState((prevState) => ({
              ...prevState,
              pagination: {
                ...prevState.pagination,
                activePage: returnedActivePage,
                totalPages
              },
              data,
              loading: false,
              error: null
            }));
          } catch (error) {
            this.setState((prevState) => ({
              ...prevState,
              data: [],
              loading: false,
              error: {
                title: 'Server error!!',
                message:
                  'Server returned an error. Please contact the Dev team to resolve the issue.'
              }
            }));
          }
        }, 1000);

        this.setState((prevState) => ({
          ...prevState,
          queryTimeoutId: newTimeoutId
        }));
      }
    );
  };

  createQueryUrl = (form, activePage = 1) => {
    const { rangeFieldNames } = this.state;

    if (Object.keys(form).length === 0) return null;

    const queryString = Object.keys(form)
      .filter((key) => rangeFieldNames.indexOf(key) === -1) // exclude range fields
      .map((key) => {
        // the key will be the name of the field which are the names of the keys in the query string.
        if (key === 'mileage' || key === 'price') {
          return `${key}=${form[key]}`;
        }
        return `${key}=${form[key]}`;
      })
      .join('&');

    return `https://pjzcaowxea.execute-api.us-east-1.amazonaws.com/dev/feeds?${queryString}&activePage=${activePage}`;
  };

  isBothRangeFieldsValid = (form, currentField, rangeField1, rangeField2) => {
    const keysInForm = Object.keys(form);

    return (
      (currentField === rangeField1 &&
        keysInForm.indexOf(rangeField2) !== -1) ||
      (currentField === rangeField2 && keysInForm.indexOf(rangeField1) !== -1)
    );
  };

  onPageChange = (event, { activePage }) => {
    this.setState(
      {
        ...this.state,
        pagination: {
          ...this.state.pagination,
          activePage
        }
      },
      () => {
        const { form } = this.state;

        this.updateQueryUrlAndFetch(form, activePage);
      }
    );
  };

  render() {
    const {
      minYearOptions,
      maxYearOptions,
      queryUrl,
      data,
      pagination,
      loading,
      vehicleStateOptions,
      inputFieldForm
    } = this.state;

    const { activePage, totalPages } = pagination;

    return (
      <Container>
        <Segment>
          <Container fluid style={{ position: 'relative' }}>
            <Header as="h2">
              Feed API
              <Header.Subheader>Create Feed Api URL.</Header.Subheader>
            </Header>
            <Popup
              content="Reset"
              trigger={
                <Button
                  floated="right"
                  icon="repeat"
                  basic
                  style={{
                    position: 'absolute',
                    top: '50%',
                    right: 0,
                    transform: 'translateY(-50%)'
                  }}
                  onClick={this.onResetButtonClick}
                />
              }
            />
          </Container>
          <Message
            style={{
              left: 0,
              bottom: 0
            }}
            info
            header={
              queryUrl
                ? 'Request will be sent to the following url address.'
                : 'No conditions have been set.'
            }
            content={queryUrl || ''}
          />
          <Form>
            <Form.Field>
              <Form.Select
                name="vehicle_state"
                label="Vehicle Condition"
                options={vehicleStateOptions}
                placeholder="Vehicle Condition"
                onChange={this.onFieldChange}
                multiple
                value={inputFieldForm.vehicle_state}
              />
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Select
                name="minYear"
                label="Min Year"
                options={minYearOptions}
                placeholder="Min year"
                onChange={this.onFieldChange}
                clearable
                value={inputFieldForm.minYear}
              />
              <Form.Select
                name="maxYear"
                label="Max Year"
                options={maxYearOptions}
                placeholder="Max year"
                onChange={this.onFieldChange}
                clearable
                value={inputFieldForm.maxYear}
              />
            </Form.Group>

            <Form.Field>
              <Form.Input
                name="make"
                label="Brand"
                placeholder="Brand"
                onChange={this.onFieldChange}
                value={inputFieldForm.make}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                name="model"
                label="Model"
                placeholder="Model"
                onChange={this.onFieldChange}
                value={inputFieldForm.model}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                name="trim"
                label="Trim"
                placeholder="Trim"
                onChange={this.onFieldChange}
                value={inputFieldForm.trim}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                name="state"
                label="State"
                placeholder="State ex) NY, PA, ..."
                onChange={this.onFieldChange}
                value={inputFieldForm.state}
              />
            </Form.Field>

            <Form.Field>
              <Form.Input
                name="dealer"
                label="Dealer"
                placeholder="Dealer"
                onChange={this.onFieldChange}
                value={inputFieldForm.dealer}
              />
            </Form.Field>

            <Form.Field>
              <Form.Input
                name="zip"
                label="Zip code"
                placeholder="Zip code"
                onChange={this.onFieldChange}
                value={inputFieldForm.zip}
              />
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Input
                name="minPrice"
                label="Min Price"
                type="number"
                placeholder="Min Price"
                onChange={this.onFieldChange}
                value={inputFieldForm.minPrice}
              />
              <Form.Input
                name="maxPrice"
                label="Max Price"
                type="number"
                placeholder="Max Price"
                onChange={this.onFieldChange}
                value={inputFieldForm.maxPrice}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Input
                name="minMileage"
                label="Min Mileage"
                type="number"
                placeholder="Min Mileage"
                onChange={this.onFieldChange}
                value={inputFieldForm.minMileage}
              />
              <Form.Input
                name="maxMileage"
                label="Max Mileage"
                type="number"
                placeholder="Max Mileage"
                onChange={this.onFieldChange}
                value={inputFieldForm.maxMileage}
              />
            </Form.Group>
          </Form>
          <Message
            style={{ left: 0, bottom: 0 }}
            warning
            header="Multiple conditions"
            list={[
              'You can set multiple conditions on the following fields. * Vin number, Dealer, Make, Model, Trim.',
              'Multiple conditions must be comma separated. Ex) Make -> Toyota,Honda',
              'OR logical operator will be applied on the fields that have multiple conditions. Ex) Make -> Toyota,Honda will find data that have Make equal to Toyota or Honda.',
              `For those range fields (Year, Price and Mileage), if only one of the fields is filled, it won't be applied to the actual queryUrl.`
            ]}
          />
        </Segment>
        <Segment
          style={{
            minHeight: '30em',
            position: 'relative',
            marginBottom: '2em'
          }}
        >
          <Dimmer active={loading} size="large">
            <Loader>Loading...</Loader>
          </Dimmer>

          {!data ||
            (data.length === 0 && (
              <Header
                as="h2"
                icon
                textAlign="center"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)'
                }}
              >
                <Icon name="database" circular />
                No results.
                <Header.Subheader>
                  Please fill out the search conditions.
                </Header.Subheader>
              </Header>
            ))}

          {data && data.length > 0 && (
            <div>
              <Table selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Vehicle Condition</Table.HeaderCell>
                    <Table.HeaderCell>Year</Table.HeaderCell>
                    <Table.HeaderCell>Brand</Table.HeaderCell>
                    <Table.HeaderCell>Model</Table.HeaderCell>
                    <Table.HeaderCell>Trim</Table.HeaderCell>
                    <Table.HeaderCell>State</Table.HeaderCell>
                    <Table.HeaderCell>Dealer</Table.HeaderCell>
                    <Table.HeaderCell>Zip</Table.HeaderCell>
                    <Table.HeaderCell>Price</Table.HeaderCell>
                    <Table.HeaderCell>Mileage</Table.HeaderCell>
                    <Table.HeaderCell>Inventory</Table.HeaderCell>
                    <Table.HeaderCell>Age</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {data.map((element) => {
                    const {
                      dealer_name: dealerName,
                      make,
                      model,
                      trim,
                      year,
                      price,
                      mileage,
                      vehicle_state: vehicleState,
                      address_info,
                      vehicle_status: vehicleStatus
                    } = element;

                    // const calcAge = Math.floor((Math.random() * 25) + 1);

                    // In_inventory
                    // eslint-disable-next-line
                    const { state, zip } = address_info || {};

                    return (
                      <Table.Row>
                        <Table.Cell>{vehicleState.toUpperCase()}</Table.Cell>
                        <Table.Cell>{year}</Table.Cell>
                        <Table.Cell>{make}</Table.Cell>
                        <Table.Cell>{model}</Table.Cell>
                        <Table.Cell>{trim}</Table.Cell>
                        <Table.Cell>{state || '-'}</Table.Cell>
                        <Table.Cell>{dealerName}</Table.Cell>
                        <Table.Cell>{zip || '-'}</Table.Cell>
                        <Table.Cell>{`$${price}`}</Table.Cell>
                        <Table.Cell>{mileage}</Table.Cell>
                        <Table.Cell>
                          {vehicleStatus === 'In_inventory'
                            ? 'In Inventory'
                            : 'Not in inventory'}
                        </Table.Cell>
                        {/* <Table.Cell>{calcAge}</Table.Cell> */}
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>

              <Container fluid textAlign="center">
                <Pagination
                  defaultActivePage={1}
                  activePage={activePage}
                  totalPages={totalPages}
                  onPageChange={this.onPageChange}
                />
              </Container>
            </div>
          )}
        </Segment>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/FeedApi/index.jsx